import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { analyseTheme } from "../../analyse/analyseTheme";
import { secondarySoft } from "./sharedStyles";

const styles = (theme: Theme) =>
  createStyles({
    welcome: {
      marginBottom: theme.spacing.unit * 4,
    },
    roleChip: {
      display: "inline-block",
      marginTop: theme.spacing.unit,
      padding: "4px 12px",
      borderRadius: analyseTheme.radiusSm,
      backgroundColor: secondarySoft,
      color: theme.palette.secondary.dark,
      fontSize: "0.875rem",
      fontWeight: 500,
    },
  });

interface Props {
  classes: {
    welcome: string;
    roleChip: string;
  };
  firstName: string;
  roleLabel: string;
}

const WelcomeWidget = ({ classes, firstName, roleLabel }: Props) => (
  <div className={classes.welcome}>
    <Typography variant="h4" gutterBottom>
      Bonjour {firstName}
    </Typography>
    <span className={classes.roleChip}>{roleLabel}</span>
  </div>
);

export default withStyles(styles)(WelcomeWidget);
